import { EVENT_SET_HALL, EventSetHallPayload } from '@weblite/ts-action/hall'

import { serverSub } from '$func/subscription'
import { hallsStorage } from './storage'

serverSub.subscribe(
  EVENT_SET_HALL,
  ({ roomId, ...fields }: EventSetHallPayload) =>
    hallsStorage.set(roomId, fields),
)
